import {
  ApproveRejectResponse,
  BookingStatus,
  EmployeeApi,
  HolidayDecisionProps,
  TextareaStyled,
  useHolidayBooking,
} from '@abdoo/common';
import { CancelOutlined, InfoOutlined } from '@mui/icons-material';
import { Box, Button, CircularProgress, Grid } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';

export const ApproveRejectCancellation = (props: HolidayDecisionProps) => {
  const { bookingId, approveOrReject } = props;
  const [error, setError] = useState<any | null>(null);
  const [data, setData] = useState<ApproveRejectResponse>();
  const [isAlreadyDecided, setIsAlreadyDecided] = useState<boolean>(false);
  const [rejectionReason, setRejectionReason] = useState<string>('');

  const { sendCancellationDecision, holidayStatus } = useHolidayBooking(
    EmployeeApi,
    bookingId,
  );

  const SendRejectDecision = useCallback(async () => {
    if (rejectionReason) {
      await sendCancellationDecision().mutationAsync(
        { ...props, rejectionReason: rejectionReason },
        setData,
        setError,
      );
    } else {
      setError('Please give a reason to complete this rejection.');
    }
  }, [rejectionReason, sendCancellationDecision, props]);

  useEffect(() => {
    if (holidayStatus.data && !data?.success) {
      if (holidayStatus.data === BookingStatus.Approved) {
        setError("You've already rejected that cancellation");
        setIsAlreadyDecided(true);
      }
      if (holidayStatus.data === BookingStatus.Cancelled) {
        setError("You've already approved that cancellation");
        setIsAlreadyDecided(true);
      }
    }
  }, [bookingId, data?.success, holidayStatus.data]);

  useEffect(() => {
    if (holidayStatus.data) {
      if (props.approveOrReject === 'approve' && !sendCancellationDecision().isLoading) {
        sendCancellationDecision().mutation(props, setData, setError);
      }
    }
    // We do not want to run this effect when sendCancellationDecision changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, holidayStatus.data]);

  const handleReasonChange = useCallback((event: any) => {
    setRejectionReason(event.target.value);
  }, []);

  const infoIcon = (
    <InfoOutlined sx={{ color: 'info.main', marginRight: '0.5rem' }}></InfoOutlined>
  );

  return (
    <Grid
      container
      gap={2}
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Box display="flex" justifyContent="center" alignItems="flex-start">
        {(approveOrReject === 'approve' ||
          (approveOrReject === 'reject' && (error || data))) &&
          (error ? (
            <>
              <CancelOutlined
                sx={{ color: 'error.main', marginRight: '0.5rem' }}
              ></CancelOutlined>
              {error}
            </>
          ) : sendCancellationDecision().isLoading ? (
            <CircularProgress />
          ) : !bookingId ? (
            <>{infoIcon}Holiday booking not found.</>
          ) : data ? (
            <>
              {infoIcon}
              {data.message}
            </>
          ) : (
            <></>
          ))}
      </Box>
      {approveOrReject === 'reject' &&
        !isAlreadyDecided &&
        !data &&
        !holidayStatus.isLoading && (
          <Box>
            <Grid mb={2} container direction="column" alignItems="flex-start">
              <p>Enter reason for rejection</p>
              <TextareaStyled
                minRows={4}
                width="20rem"
                value={rejectionReason}
                onChange={handleReasonChange}
              />
            </Grid>
            <Button variant="contained" color="primary" onClick={SendRejectDecision}>
              Reject request
            </Button>
          </Box>
        )}
    </Grid>
  );
};
